import React from "react";
import { ToggleSwitch } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import CustomSpan from "../CustomSpan";

const MachineToggle = ({ checked, handleChangeToggle, idx, row }) => {
  return (
    <div className="flex items-center w-full">
      <CustomSpan
        className="text-tenken-gray-900 mr-2 whitespace-nowrap cursor-pointer"
        text="無効"
        onClick={() => handleChangeToggle(false, idx, "status", row)}
      />
      <ToggleSwitch
        theme={tenkenTheme}
        color="primary"
        checked={checked}
        onChange={() => handleChangeToggle(!checked, idx, "status", row)}
      />
      <CustomSpan
        className="text-tenken-gray-900 ml-2 whitespace-nowrap cursor-pointer"
        text="有効"
        onClick={() => handleChangeToggle(true, idx, "status", row)}
      />
    </div>
  );
};

export default MachineToggle;
